<template>
  <div id="content-container">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="分类详情">
      </el-page-header>
      <el-descriptions title="" :column="1">
        <el-descriptions-item label="名称"
          >{{ item.name
          }}<el-tag size="mini" type="primary" v-if="item.type == 2"
            >耗材</el-tag
          ></el-descriptions-item
        >
        <el-descriptions-item label="寿命预警条件" v-if="item.category == 2"
          >最近一次维修后：寿命值达到<span class="text-danger">{{
            item.warning_current_day
          }}</span
          >天
          <span class="text-danger ml-5 mr-5">{{
            item.warning_condition_type == 2 ? '且' : '或'
          }}</span>
          工作时长达到
          <span class="text-danger">{{ item.warning_current_hour }}</span
          >小时</el-descriptions-item
        >
        <el-descriptions-item label="配件属性">
          <el-breadcrumb separator="|">
            <el-breadcrumb-item>编号</el-breadcrumb-item>
            <el-breadcrumb-item>名称</el-breadcrumb-item>
            <el-breadcrumb-item>型号</el-breadcrumb-item>
            <el-breadcrumb-item
              v-for="(item, index) in item.custom_params"
              :key="item.label + index"
              >{{ item.label }}</el-breadcrumb-item
            >
            <el-breadcrumb-item>期初使用时间</el-breadcrumb-item>
            <el-breadcrumb-item>状态</el-breadcrumb-item>
            <el-breadcrumb-item>平均寿命</el-breadcrumb-item>
            <el-breadcrumb-item>备注</el-breadcrumb-item>
          </el-breadcrumb>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="panel">
      <el-tabs>
        <el-tab-pane label="配件列表">
          <ItemIndex
            :category="item.category"
            :itemTemplateId="item.id"
            v-if="item.id"
          ></ItemIndex>
        </el-tab-pane>
        <el-tab-pane label="库存分布" v-if="item.category == 2">
          <Statistic :itemTemplateId="item.id" v-if="item.id"></Statistic>
        </el-tab-pane>
        <el-tab-pane label="寿命分析表">
          <AgeAnalyze :temp="item" v-if="item.id"></AgeAnalyze>
        </el-tab-pane>
        <el-tab-pane label="维修分析表">
          <RepairAnalyze :temp="item" v-if="item.id"></RepairAnalyze>
        </el-tab-pane>
        <el-tab-pane
          label="预警条件设置"
          name="tabwarning"
          v-if="item.category == 1 && hasAuth('itemTemplateEdit')"
        >
          <WarningRule :itemTemplateId="item.id"></WarningRule>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { itemTemplateDetail } from '@/service/getData'
import AgeAnalyze from './age_analyze.vue'
import RepairAnalyze from './repair_analyze.vue'
import ItemIndex from '../items/index'
import Statistic from './statistic.vue'
import WarningRule from '../warning_rules/index'
export default {
  components: {
    ItemIndex,
    AgeAnalyze,
    RepairAnalyze,
    Statistic,
    WarningRule,
  },
  data() {
    return {
      item: {
        id: 0,
        items: [],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await itemTemplateDetail(this.$route.params.id)
      if (res.code == 0) {
        this.item = res.data
      }
    },
  },
}
</script>

<style>
.el-timeline-item {
  padding-bottom: 10px;
}
</style>